import { DevicesManagerService } from '../../services/devices-manager.service';

export const DEVICE_STATUS = {
  fullyStopped: {
    text: 'A l’arrêt (contact éteint)',
    value: 'fullyStopped',
  },
  stopped: {
    text: 'A l’arrêt (contact allumé)',
    value: 'stopped',
  },
  moving: {
    text: 'En déplacement',
    value: 'moving',
  },
  inactive: {
    text: 'inactive',
    value: 'inactive',
  },
} as const;

export type DEVICE_STATUS_VALUES = keyof typeof DEVICE_STATUS;

class SocketLocation {
  public id_broker_device: string;
  public fk_device: number;
  public fk_account: number;
  public fk_unit: number;
  public fk_symbol: number;
  public dev_hw_id: string;
  public registration: string;
  public summary: string;
  public startup: number;
  public last_event: number;
  public last_stop: number;
  public last_start: number;
  public special_flag: number;
  public max_speed: number;
  public location_date: number;
  public location_utc_date: number;
  public location_radius: number;
  public location_longitude: number;
  public location_latitude: number;
  public location_speed: number;
  public location_input: number;
  public location_course: number;
  public location_address: string;
  public created_at: number;
  public updated_at: number;
  public hdop: number | null;

  // Normalization
  public uid: number;
  public movingStatus: (typeof DEVICE_STATUS)[DEVICE_STATUS_VALUES];
  public newStatus = 1 | 2 | 3;
  public course: number;
  public longitude: number;
  public latitude: number;
  public id_symbol: number;
  public uid_parent: number;
  public address: string;
  public isPrivacy: boolean;
  public icon: number;
  public speed_current: number | null;
  public speed_max: number;
  public deviceStatusClass: string;
  public input: number | null;
  public isBlurHdop: boolean;

  public source = 'socket';

  constructor(data) {
    Object.assign(this, data);
    this.normalize();
  }

  // Do this in case of spread
  public normalize() {
    this.uid = this.fk_device;
    this.course = this.location_course;
    this.location_date = this.location_date ?? this.location_utc_date;
    this.speed_current = this.location_speed;
    this.input = this.location_input;
    this.course = this.location_course;
    this.speed_max = this.max_speed;
    this.longitude = this.location_longitude;
    this.latitude = this.location_latitude;
    this.id_symbol = this.fk_symbol;
    this.uid_parent = this.fk_unit;
    this.address = this.location_address;
    this.hdop = this.location_radius;
    this.registration = this.registration || this.uid.toString();
    this.isPrivacy = this.hasPrivacy();

    DevicesManagerService.setHDOP(this);
    DevicesManagerService.setStatusDevice(this);
  }

  /**
   * Get if the current state of device is privacy or not
   */
  public hasPrivacy() {
    return (this.special_flag & 2) !== 0;
  }
}

export default SocketLocation;
